import { LocalPlansType } from "@/types/PlansType";

export const localPlans: LocalPlansType[] = [
  {
    id: process.env.VUE_APP_PLAN_8_GB_NP,
    catalogId: process.env.VUE_APP_CATALOG_8_GB_NP,
    name: "8GB do plano + 2GB de bônus <br>para redes e vídeos",
    catalogTag: process.env.VUE_APP_TAG_8_GB_NP,
    title: "10GB",
    franchise: 8,
    bonus: 2,
    appsTitle: "Apps inclusos no bônus para redes e vídeos",
    apps: ["youtube", "waze"],
    unlimitedAppsTitle: "App Ilimitado",
    unlimitedApps: [
      {
        icon: "mdn-Icon-whatsapp mdn-Icon--md",
        alt: "Whatsapp",
        color: "#2fd74d",
        description: "Whatsapp sem descontar da sua franquia",
      },
    ],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "Assinatura inclusa",
    skeelo: true,
    coupon: "VIRAFLEX15",
    price: 34.99,
    details: {
      title: "Claro flex 8GB",
      priceDescription: "Apenas: R$ 34,99 /mês",
      instructionTitle: "Instruções para ativação",
      instruction: [
        "Comprar um chipflex ou",
        "Necessário possuir um chip Claro pré.",
      ],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 8GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul><li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></ul>",
        "<b>Aplicativos exclusivo para navegar com o 2GB Bônus de redes e Vídeos</b><br /><ul><li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li><li><span>Youtube: É uma plataforma que possibilita aos seus usuários carregar e compartilhar vídeos em formato digital.</span></li></ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Youtube",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Waze",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
      {
        description: "SMS",
        type: "Incluso",
      },
    ],
  },
  // {
  //   id: process.env.VUE_APP_PLAN_8_GB,
  //   catalogId: process.env.VUE_APP_CATALOG_8_GB,
  //   name: "8GB do plano + 2GB de bônus para redes e vídeos",
  //   catalogTag: process.env.VUE_APP_TAG_8_GB,
  //   title: "10GB",
  //   franchise: 8,
  //   bonus: 2,
  //
  //   appsTitle: "Apps inclusos no bônus para redes e vídeos",
  //   apps: ["youtube", "waze"],
  //   unlimitedAppsTitle: "App Ilimitado",
  //   unlimitedApps: [
  //     {
  //       icon: "mdn-Icon-whatsapp mdn-Icon--md",
  //       alt: "Whatsapp",
  //       color: "#2fd74d",
  //       description: "Whatsapp sem descontar da sua franquia",
  //     },
  //   ],
  //   servicesTitle: "Serviços ilimitados",
  //   services: [
  //     {
  //       icon: "mdn-Icon-claro mdn-Icon--md",
  //       alt: "Ligações Claro para Claro",
  //       color: "#E3262E",
  //       description: "Ligações Claro para Claro",
  //     },
  //     {
  //       icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
  //       alt: "Ligações outras operadoras",
  //       color: "#E3262E",
  //       description: "Ligações outras operadoras",
  //     },
  //     {
  //       icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
  //       alt: "SMS nacional Claro para Claro",
  //       color: "#E3262E",
  //       description: "SMS nacional Claro para Claro",
  //     },
  //   ],
  //   includeTitle: "Assinatura inclusa",
  //   skeelo: true,
  //   coupon: "VIRAFLEX10",
  //   price: 29.99,
  //   details: {
  //     title: "Claro flex 8GB",
  //     priceDescription: "Apenas: R$ 29,99 /mês",
  //     instructionTitle: "Instruções para ativação",
  //     instruction: [
  //       "Comprar um chipflex ou",
  //       "Necessário possuir um chip Claro pré.",
  //     ],
  //     benefitsTitle: "Benefícios do plano",
  //     benefits: [
  //       "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
  //       "Internet: o seu plano tem 8GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região.",
  //       "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
  //       "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul><li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></ul>",
  //       "<b>Aplicativos exclusivo para navegar com o 2GB Bônus de redes e Vídeos</b><br /><ul><li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li><li><span>Youtube: É uma plataforma que possibilita aos seus usuários carregar e compartilhar vídeos em formato digital.</span></li></ul>",
  //     ],
  //   },
  //   successDetails: [
  //     {
  //       description: "Ligações Claro para Claro",
  //       type: "Ilimitado",
  //     },
  //     {
  //       description: "Ligações outras operadoras",
  //       type: "Ilimitado",
  //     },
  //     {
  //       description: "Claro Música",
  //       type: "Ilimitado",
  //     },
  //     {
  //       description: "WhatsApp",
  //       type: "Ilimitado",
  //     },
  //     {
  //       description: "Youtube",
  //       type: "Incluso no bônus redes e vídeos",
  //     },
  //     {
  //       description: "Waze",
  //       type: "Incluso no bônus redes e vídeos",
  //     },
  //     {
  //       description: "Skeelo",
  //       type: "Incluso",
  //     },
  //     {
  //       description: "SMS",
  //       type: "Incluso",
  //     },
  //   ],
  // },
  {
    id: process.env.VUE_APP_PLAN_15_GB,
    catalogId: process.env.VUE_APP_CATALOG_15_GB,
    name: "15GB do plano + 5GB de bônus para redes e vídeos",
    catalogTag: process.env.VUE_APP_TAG_15_GB,
    title: "20GB",
    franchise: 15,
    bonus: 5,

    appsTitle: "Apps inclusos no bônus para redes e vídeos",
    apps: ["tiktok", "facebook", "youtube", "instagram", "twitter", "waze"],
    unlimitedAppsTitle: "App Ilimitado",
    unlimitedApps: [
      {
        icon: "mdn-Icon-whatsapp mdn-Icon--md",
        alt: "Whatsapp",
        color: "#2fd74d",
        description: "Whatsapp sem descontar da sua franquia",
      },
    ],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "Assinatura inclusa",
    skeelo: true,
    coupon: "VIRAFLEX20",
    price: 39.99,
    details: {
      title: "Claro flex 15 GB",
      priceDescription: "Apenas: R$ 39,99 /mês",
      instructionTitle: "Instruções para ativação",
      instruction: [
        "Comprar um chipflex ou",
        "Necessário possuir um chip Claro pré.",
      ],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 15 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul><li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></ul>",
        "<b>Aplicativos exclusivo para navegar com o 5GB Bônus de redes e Vídeos</b><br /><ul>" +
          "<li><span>TikTok: assista os vídeos e trend sem descontar da sua franquia. Não perca nenhum conteúdo do app que é utilizado por milhares de influenciadores do Brasil e do mundo.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Youtube: É uma plataforma que possibilita aos seus usuários carregar e compartilhar vídeos em formato digital.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X : participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Tiktok",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Youtube",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Waze",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Facebook",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Instagram",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Twitter",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
      {
        description: "SMS",
        type: "Incluso",
      },
    ],
  },
  {
    id: process.env.VUE_APP_PLAN_20_GB,
    catalogId: process.env.VUE_APP_CATALOG_20_GB,
    name: "20GB do plano + 5GB de bônus para redes e vídeos",
    catalogTag: process.env.VUE_APP_TAG_20_GB,
    title: "25GB",
    franchise: 20,
    bonus: 5,

    appsTitle: "Apps inclusos no bônus para redes e vídeos",
    apps: ["tiktok", "facebook", "youtube", "instagram", "twitter", "waze"],
    unlimitedAppsTitle: "App Ilimitado",
    unlimitedApps: [
      {
        icon: "mdn-Icon-whatsapp mdn-Icon--md",
        alt: "Whatsapp",
        color: "#2fd74d",
        description: "Whatsapp sem descontar da sua franquia",
      },
    ],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "Assinatura inclusa",
    skeelo: true,
    coupon: "VIRAFLEX20",
    price: 49.99,
    details: {
      title: "Claro flex 20 GB",
      priceDescription: "Apenas: R$ 49,99 /mês",
      instructionTitle: "Instruções para ativação",
      instruction: [
        "Comprar um chipflex ou",
        "Necessário possuir um chip Claro pré.",
      ],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 20 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul><li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></ul>",
        "<b>Aplicativos exclusivo para navegar com o 5GB Bônus de redes e Vídeos</b><br /><ul>" +
          "<li><span>TikTok: assista os vídeos e trend sem descontar da sua franquia. Não perca nenhum conteúdo do app que é utilizado por milhares de influenciadores do Brasil e do mundo.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X : participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "<li><span>Youtube: É uma plataforma que possibilita aos seus usuários carregar e compartilhar vídeos em formato digital.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Tiktok",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Youtube",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Waze",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Facebook",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Instagram",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Twitter",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
      {
        description: "SMS",
        type: "Incluso",
      },
    ],
  },
  {
    id: process.env.VUE_APP_PLAN_30_GB,
    catalogId: process.env.VUE_APP_CATALOG_30_GB,
    name: "30GB do plano + 5GB de bônus para redes e vídeos",
    catalogTag: process.env.VUE_APP_TAG_30_GB,
    title: "35GB",
    franchise: 30,
    bonus: 5,
    appsTitle: "Apps inclusos no bônus para redes e vídeos",
    apps: [
      "freefire",
      "tiktok",
      "facebook",
      "youtube",
      "instagram",
      "twitter",
      "waze",
    ],
    unlimitedAppsTitle: "App Ilimitado",
    unlimitedApps: [
      {
        icon: "mdn-Icon-whatsapp mdn-Icon--md",
        alt: "Whatsapp",
        color: "#2fd74d",
        description: "Whatsapp sem descontar da sua franquia",
      },
    ],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "Assinatura inclusa",
    skeelo: true,
    coupon: "VIRAFLEX20",
    price: 59.99,
    details: {
      title: "Claro flex 30 GB",
      priceDescription: "Apenas: R$ 59,99 /mês",
      instructionTitle: "Instruções para ativação",
      instruction: [
        "Comprar um chipflex ou",
        "Necessário possuir um chip Claro pré.",
      ],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 30 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul><li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></ul>",
        "<b>Aplicativos exclusivo para navegar com o 5GB Bônus de redes e Vídeos</b><br /><ul>" +
          "<li><span>Free Fire: É um jogo Battle Royale de celular mais popular do Brasil! Jogue sem descontar da sua franquia. Não perca mais nenhuma partida.</span></li>" +
          "<li><span>TikTok: assista os vídeos e trend sem descontar da sua franquia. Não perca nenhum conteúdo do app que é utilizado por milhares de influenciadores do Brasil e do mundo.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X : participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "<li><span>Youtube: É uma plataforma que possibilita aos seus usuários carregar e compartilhar vídeos em formato digital.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Free Fire",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Tiktok",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Youtube",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Waze",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Facebook",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Instagram",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Twitter",
        type: "Incluso no bônus redes e vídeos",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
      {
        description: "SMS",
        type: "Incluso",
      },
    ],
  },
];
